import "./styles/style.css";
import { SectionOne } from "./parts/section-one";
import { SectionTwo } from "./parts/section-two";
import { SectionThree } from "./parts/section-three";
import { SectionSix } from "./parts/section-six";
import { SectionFour } from "./parts/section-four";
import { useMediaQuery } from "react-responsive";
import { Link, useLocation } from 'react-router-dom';
import React, { useState } from 'react';
const KwikCkeckOutCod = () => {

  const [navbarVisible, setNavbarVisible] = useState(false);
  const location = useLocation();

  const isMobile = useMediaQuery({ maxWidth: 768 });
  const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });
  const mobileToggle = () => setNavbarVisible(!navbarVisible);
  const mobileSubMenClose = () => setNavbarVisible(false);
  const isKwikCheckoutCOD = false; // static flag
  return (
    <div className="kwik-checkout">
      {
       isMobile && (
          <header id="header" className="header header-mob-checkout d-flex align-items-center " style={{
            backgroundColor: "#fff",
            fontWeight: "300",
            top: 0,                  // stick to top
            zIndex: 999,
            width: '100%',
            position: "fixed",     // makes it sticky

          }}>
            <div className="container-fluid d-flex align-items-center justify-content-between">
              <Link
                to="/"
                className="logo d-flex align-items-center me-auto me-lg-0"
                style={{ visibility: isKwikCheckoutCOD ? 'hidden' : 'visible' }}
              >
                <img
                  src="/assets/images/logo2.png"
                  width="137"
                  height="40"
                  alt="GoKwik"
                />
              </Link>

              <nav id="navbar" className={navbarVisible ? 'navbar show' : 'navbar'}>
              </nav>  <button onClick={scrollToTop} className="cta">
                Book a Demo

              </button>
            </div>


          </header>)
      }

      <SectionOne />
      <SectionTwo />
      <SectionThree />
      <SectionFour />
      <SectionSix />
    </div>
  );
};

export default KwikCkeckOutCod;
